import { useNavigate } from 'react-router-dom';
import { Grid, Button } from '@mui/material';
import { useAuthorize } from '../../../hooks/use-authorize';
import { UserPermissionName } from '../../../models/user-permission-name';

interface ActionPage {
  isLoading: boolean;
  page: string;
  handleCancel: () => void;
  handleSubmit: (data: any) => any;
}

const styling = {
  root: { paddingRight: '15px', paddingBottom: '10px' },
  buttonStyle: { width: '130px' },
};

export const FormButtons = ({ isLoading, page, handleCancel, handleSubmit }: ActionPage) => {
  const navigate = useNavigate();
  const onCancel = () => {
    handleCancel();
    // navigate(`/customers/details/${customerID}`);
  };

  const isReadOnlyPermission = useAuthorize([UserPermissionName?.READ_ONLY]);

  return (
    <Grid container justifyContent="space-between" spacing={1}>
      <Grid item>
        <Button variant="outlined" style={styling.buttonStyle} onClick={onCancel}>
          Cancel
        </Button>
      </Grid>
      {page == 'edit' ?
        <Grid item>
          <Button
            type={'button'}
            disabled={isLoading || isReadOnlyPermission}
            variant="contained"
            disableElevation={true}
            style={{
              color: 'white',
              backgroundColor:
                isLoading || isReadOnlyPermission
                  ? '#9F9FA9'
                  : '#e67e22', width: '250px'
            }}
            onClick={() => handleSubmit('without-workorder')}
          >
            Save Without Workorder
          </Button>
          <Button
            type={'button'}
            disabled={isLoading || isReadOnlyPermission}
            variant="contained"
            disableElevation={true}
            style={{
              color: 'white',
              backgroundColor:
                isLoading || isReadOnlyPermission
                  ? '#9F9FA9'
                  : '#239b56', width: '250px', marginLeft: 10
            }}
            onClick={() => handleSubmit('with-workorder')}
          >
            Save with workorder
          </Button>

        </Grid> :
        <Grid item>
          <Button
            type={'button'}
            disabled={isLoading || isReadOnlyPermission}
            variant="contained"
            disableElevation={true}
            style={styling.buttonStyle}
            onClick={() => handleSubmit('without-workorder')}
          >
            Save
          </Button>
        </Grid>
      }
    </Grid>
  );
};
